import { z } from 'zod';
import i18next from 'i18next';

export const forgotPasswordSchema = z.object({
  email: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailRequired'),
      });
    } else if (!z.string().email().safeParse(data).success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailFormatIncorrect'),
      });
    }
  }),
});

export type TForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>;
